"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterKickedDTO = exports.CharacterUpdatedDTO = exports.DeleteCharacterDTO = exports.UpdateCharacterDTO = exports.GetTopBattleCharactersForUserDTO = exports.GetCharactersByUserIdDTO = exports.CharacterIdDTO = exports.CharacterListDTO = exports.CreateCharacterFromCivilianDTO = exports.CreateCharacterDTO = exports.CharacterDTO = exports.GetCharacterDTO = exports.CharacterStats = exports.CharacterVariants = exports.CharacterTypes = void 0;
const class_validator_1 = require("class-validator");
const Battle_1 = require("./Battle");
var CharacterTypes;
(function (CharacterTypes) {
    CharacterTypes["GirlAmazon"] = "GirlAmazon";
    CharacterTypes["StrongBrute"] = "StrongBrute";
    CharacterTypes["SmartMedic"] = "SmartMedic";
    CharacterTypes["AgileRanger"] = "AgileRanger";
})(CharacterTypes = exports.CharacterTypes || (exports.CharacterTypes = {}));
var CharacterVariants;
(function (CharacterVariants) {
    CharacterVariants[CharacterVariants["One"] = 1] = "One";
    CharacterVariants[CharacterVariants["Two"] = 2] = "Two";
    CharacterVariants[CharacterVariants["Three"] = 3] = "Three";
})(CharacterVariants = exports.CharacterVariants || (exports.CharacterVariants = {}));
var CharacterStats;
(function (CharacterStats) {
    CharacterStats["Ammunition"] = "Ammunition";
    CharacterStats["Armor"] = "Armor";
    CharacterStats["Dodge"] = "Dodge";
    CharacterStats["Health"] = "Health";
    CharacterStats["Movement"] = "Movement";
    CharacterStats["Damage"] = "Damage";
    CharacterStats["Accuracy"] = "Accuracy";
    CharacterStats["Heal"] = "Heal";
    CharacterStats["RangeMin"] = "RangeMin";
    CharacterStats["RangeMax"] = "RangeMax";
    CharacterStats["Resistance"] = "Resistance";
})(CharacterStats = exports.CharacterStats || (exports.CharacterStats = {}));
let GetCharacterDTO = (() => {
    class GetCharacterDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetCharacterDTO.prototype, "characterId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetCharacterDTO.prototype, "userId", void 0);
    return GetCharacterDTO;
})();
exports.GetCharacterDTO = GetCharacterDTO;
class CharacterDTO {
}
exports.CharacterDTO = CharacterDTO;
let CreateCharacterDTO = (() => {
    class CreateCharacterDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreateCharacterDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsEnum(CharacterTypes),
        __metadata("design:type", String)
    ], CreateCharacterDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CreateCharacterDTO.prototype, "level", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CreateCharacterDTO.prototype, "stars", void 0);
    __decorate([
        class_validator_1.IsEnum(CharacterVariants),
        __metadata("design:type", Number)
    ], CreateCharacterDTO.prototype, "variant", void 0);
    __decorate([
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Array)
    ], CreateCharacterDTO.prototype, "skills", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], CreateCharacterDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Array)
    ], CreateCharacterDTO.prototype, "itemTemplates", void 0);
    return CreateCharacterDTO;
})();
exports.CreateCharacterDTO = CreateCharacterDTO;
let CreateCharacterFromCivilianDTO = (() => {
    class CreateCharacterFromCivilianDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], CreateCharacterFromCivilianDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsEnum(CharacterTypes),
        __metadata("design:type", String)
    ], CreateCharacterFromCivilianDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CreateCharacterFromCivilianDTO.prototype, "stars", void 0);
    return CreateCharacterFromCivilianDTO;
})();
exports.CreateCharacterFromCivilianDTO = CreateCharacterFromCivilianDTO;
class CharacterListDTO {
}
exports.CharacterListDTO = CharacterListDTO;
class CharacterIdDTO {
}
exports.CharacterIdDTO = CharacterIdDTO;
let GetCharactersByUserIdDTO = (() => {
    class GetCharactersByUserIdDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetCharactersByUserIdDTO.prototype, "userId", void 0);
    return GetCharactersByUserIdDTO;
})();
exports.GetCharactersByUserIdDTO = GetCharactersByUserIdDTO;
let GetTopBattleCharactersForUserDTO = (() => {
    class GetTopBattleCharactersForUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetTopBattleCharactersForUserDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsEnum(Battle_1.Difficulty),
        __metadata("design:type", String)
    ], GetTopBattleCharactersForUserDTO.prototype, "battleDifficulty", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], GetTopBattleCharactersForUserDTO.prototype, "level", void 0);
    return GetTopBattleCharactersForUserDTO;
})();
exports.GetTopBattleCharactersForUserDTO = GetTopBattleCharactersForUserDTO;
let UpdateCharacterDTO = (() => {
    class UpdateCharacterDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateCharacterDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateCharacterDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsEnum(CharacterTypes),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateCharacterDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UpdateCharacterDTO.prototype, "level", void 0);
    __decorate([
        class_validator_1.IsEnum(CharacterVariants),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UpdateCharacterDTO.prototype, "variant", void 0);
    __decorate([
        class_validator_1.IsString({ each: true }),
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], UpdateCharacterDTO.prototype, "skills", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateCharacterDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsString({ each: true }),
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], UpdateCharacterDTO.prototype, "itemTemplates", void 0);
    return UpdateCharacterDTO;
})();
exports.UpdateCharacterDTO = UpdateCharacterDTO;
let DeleteCharacterDTO = (() => {
    class DeleteCharacterDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], DeleteCharacterDTO.prototype, "id", void 0);
    return DeleteCharacterDTO;
})();
exports.DeleteCharacterDTO = DeleteCharacterDTO;
class CharacterUpdatedDTO {
}
exports.CharacterUpdatedDTO = CharacterUpdatedDTO;
class CharacterKickedDTO {
}
exports.CharacterKickedDTO = CharacterKickedDTO;
//# sourceMappingURL=Character.js.map